
import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from 'react'
import { api, USING_MOCK } from '../services/api'

const AuthContext = createContext(null)
const KEY = 'ipoint-admin-token'

const readToken = () => {
  try {
    return localStorage.getItem(KEY) || ''
  } catch {
    return ''
  }
}

export function AuthProvider({ children }) {
  const [token, setToken] = useState(readToken)

  const login = useCallback(async (email, password) => {
    let newToken

    if (typeof api.login === 'function') {
      const response = await api.login(email, password)

      newToken =
        response?.token ||
        response?.data?.token ||
        (typeof response === 'string' ? response : '')

      if (!newToken) {
        throw new Error(
          response?.message ||
          'Login failed: the server did not return an authentication token.'
        )
      }
    } else if (USING_MOCK) {
      if (
        email.toLowerCase() !== 'admin@ipoint.com' ||
        password !== 'admin123'
      ) {
        throw new Error('Wrong email or password')
      }

      newToken = 'demo-token'
    } else {
      throw new Error('Login is not available')
    }

    try {
      localStorage.setItem(KEY, newToken)
    } catch {}

    setToken(newToken)
  }, [])

  const logout = useCallback(() => {
    try {
      localStorage.removeItem(KEY)
    } catch {}

    setToken('')
  }, [])

  const value = useMemo(
    () => ({
      token,
      isAuthed: !!token,
      login,
      logout,
    }),
    [token, login, logout]
  )

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  )
}

export const useAuth = () => useContext(AuthContext)
